import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { updateDataVisibility } from '../../store/actions/data.actions';
import { DATA } from '../../store/reducer/data.reducer';
import { CONFIG } from '../../store/reducer/config.reducer';
import { svgScaleReset, updatePage } from '../../store/actions/config.actions';
import { PartieMachineNodeWithDetails, selectPartieMachineNodesWithDetails } from '../../store/selectors/data.selector';

@Component({
    selector: 'app-search-list',
    templateUrl: './search-list.component.html',
    styleUrls: ['./search-list.component.scss'],
    standalone: false
})
export class SearchListComponent {
  @Input() searchVal = '';

  pages$: Observable<PartieMachineNodeWithDetails[]> = this.store.select(selectPartieMachineNodesWithDetails);
  config$: Observable<CONFIG> = this.store.select((state) => state.config);

  constructor(
    private store: Store<{
      data: DATA;
      config: CONFIG;
    }>
  ) {
  }

  toogleVisibility(index) {
    this.store.dispatch(updateDataVisibility({ index }));
  }

  changePageNumber(selectedNumPage) {
    this.store.dispatch(updatePage(Number(selectedNumPage)));
    this.store.dispatch(svgScaleReset());
  }
}
